import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "4 14 10 14 10 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "20 10 14 10 14 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "21", y1: "10", y2: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "10", y1: "21", y2: "14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Minimize2";
const Minimize2 = memo(themed(Icon));
export {
  Minimize2
};
//# sourceMappingURL=minimize-2.js.map
